import React, { useState, useEffect, useRef } from 'react';
import style from './MedicalReservationOutDetails.module.css';
import HeadSub from '../../../../components/comm/HeadSub';


const MedicalReservationOutDetails = () => {
    
    return (
        <>
            <HeadSub title="진료 예약 내역 상세"/>

            <div id="sub-content" data-layout="white">     
                <div className='inner-wrap' data-pad-type="a">
                    <div className={style['header-d-day-box']}>
                        <div className={style['in-box']}> 
                            <p>진료일까지 <b>15일</b> 남았어요.</p>
                        </div>
                    </div>

                    {/* 기본 정보 */}
                    <div className={style["detail-box"]} data-type="a">
                        <div className={style["head"]}>
                            <h2>기본정보</h2>   
                            <button className='btn' data-btn-type="fill-gray" data-btn-size='sm' data-btn-icon='share'>
                                <span>진료 일정 공유</span>
                            </button>
                        </div>
                        <div className={style["mid"]}>
                            <div className={style["inner-box"]}>
                                <ul>
                                    <li>
                                        <p>예약일시</p>
                                        <span>24.12.12(월) 오후 01:30</span>
                                    </li>
                                    <li>
                                        <p>진료구분</p>
                                        <span>비대면면</span>
                                    </li>
                                    <li>
                                        <p>병원</p>
                                        <span>서울성모병원</span>
                                    </li>
                                    <li>
                                        <p>진료과</p>
                                        <span>신경외과</span>
                                    </li>
                                    <li>
                                        <p>의료진</p>
                                        <span>김미소</span>
                                    </li>
                                    <li>
                                        <p>증상</p>
                                        <span>3년 전에 다친 발목이 계속 아픔 통증이 모스 부호처럼 계속 느껴짐 그래서 동네 의사가 큰 병원 가보라고 했습니다.</span>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className={style["botm"]}>
                            <ul>
                                <li>
                                    <span>진료 예약/취소/변경은 서울성모병원 앱/홈페이지 또는 카카오톡 케어챗에서 가능합니다.</span>
                                </li>
                                <li>
                                    <span>진료 예약 관련 궁금하신 점이 있으시면 00-0000-0000으로 문의 바랍니다.</span>
                                </li>
                            </ul>    
                        </div>    
                    </div>


                    {/* 상세 정보 */}
                    <div className={style["detail-box"]} data-type="b">
                        <div className={style["head"]}>
                            <h2>상세 정보</h2>   
                        </div>
                        
                        <div className={style["mid"]}>

                            <div className={style['hospital-sch-wrap']}>
                                <div className={style['history-box']} data-history-box="out">
                                    <ul>
                                        <li className={style['history-list']}>
                                            <div className={style['history-head']}>
                                                <div className={style['his-date']}>
                                                    <strong>진료</strong>
                                                    <p>오후 2시 30분</p>
                                                </div>
                                                <div className={style['history-mid']}>
                                                    <strong>정신건강의학과</strong>
                                                    <p>김대진 교수님</p>
                                                </div>
                                                
                                                <div className={style['btn-boxs']}>
                                                    <button className='btn' data-btn-type="fill-gray" data-btn-size='smd'>
                                                        <span>사전 안내</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div> 
                            </div>

                        </div>
                    </div>

                    <div className={style['btn-box']}>
                        <button className="btn" data-btn-type="fill-main" data-btn-size="lg" data-btn-width='full'>
                            <span>진료 상세</span>
                        </button>
                    </div>


                    {/* 비대면 진료 주의사항 */}
                    <div className={style["detail-box"]} data-type="a">
                        <div className={style["head"]}>
                            <h2>비대면 진료 주의사항</h2>   
                        </div>
                        
                        <div className={style["botm"]}>
                            <ul>
                                <li>
                                    <span>진료 예약/취소/변경은 서울성모병원 앱/홈페이지 또는 카카오톡 케어챗에서 가능합니다.</span>
                                </li>
                                <li>
                                    <span>진료 예약 관련 궁금하신 점이 있으시면 00-0000-0000으로 문의 바랍니다.</span>
                                </li>
                            </ul>    
                        </div>                        
                    </div>




                    {/* 하단 다음 버튼 영역 :: S */}
                    <div className={style["bottom-fixed-box"]}>
                        <div className={style["inner-box"]}>

                            <div className={style['notice-txts']}>
                                <p>24.12.23(화) 오후 00:00부터 오후 00:00까지</p>
                                {/* <p>비대면 진료가 종료되었습니다</p> */}

                                <span>진료실 입장이 가능합니다</span>
                                {/* <span>진료비를 수납하고 근처 약국으로 처방전을 전송하세요.</span> */}
                            </div>
                            <div className={style['btn-layout']}> 
                                <button className="btn" data-btn-type="fill-main" data-btn-size="lg">
                                    <span>진료실 입장하기</span>
                                </button>

                                {/* <button disabled className="btn" data-btn-type="fill-main-sub" data-btn-size="lg">
                                    <span>진료비 수납완료</span>
                                </button> */}
                                {/* <button className="btn" data-btn-type="fill-main-sub" data-btn-size="lg">
                                    <span>처방전 확인하기</span>
                                </button> */}
                            </div>
                            
                        </div>
                    </div>               
                    {/* 하단 다음 버튼 영역 :: E */} 



                   
                </div>
            </div>
        </>
    );
};

export default MedicalReservationOutDetails;
